import { Row, Col } from "react-bootstrap";

export const ThreeDashLoader = (text) => (
  <>
    <Col style={{ top: "50%", position: "absolute", transform: "translateY(-50%)" }}>
      <Row>
        <div className="text-center">
          <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="text-center">{text}</div>
      </Row>
    </Col>
  </>
);